import ScrollReveal from "@/components/ScrollReveal";
import LeadForm from "@/components/LeadForm";

export default function LeadGenCTA({ source = "homepage" }) {
  return (
    <section data-testid="leadgen-section" className="relative bg-slate1 text-white py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-radial-glow opacity-60 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] rounded-full bg-radial-glow opacity-40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <ScrollReveal className="lg:col-span-5 lg:sticky lg:top-32">
          <div className="text-xs tracking-[0.22em] uppercase text-teal2 font-semibold">
            Bring XcellerEYES to Your Practice
          </div>
          <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-medium leading-tight">
            Ready to elevate <span className="text-gradient-teal-bright">ocular surface</span> care?
          </h2>
          <p className="mt-8 text-lg text-white/70 leading-relaxed">
            Tell us about your practice. A RenVia clinical specialist will reach out within one
            business day to discuss product evaluation, ordering, and clinical support.
          </p>

          <ul className="mt-10 space-y-4">
            {[
              "Personalized product evaluation",
              "Clinical onboarding & training",
              "Dedicated commercial support",
              "Streamlined ordering through your existing workflow",
            ].map((t) => (
              <li key={t} className="flex items-start gap-3 text-white/85">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-teal2" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </ScrollReveal>

        <ScrollReveal delay={140} className="lg:col-span-7">
          <LeadForm source={source} variant="dark" />
        </ScrollReveal>
      </div>
    </section>
  );
}
